import { Box, Typography } from '@mui/material';
import { useIntl } from 'react-intl';

/**
 * OR-6432 Block B — page shell only. Agent-first session search & replay
 * (Block C) aren't built yet; this renders the gated route and a placeholder
 * so the page is reachable and verifiably empty. Single-gate authorization
 * (is_internal + flag) is the only check — no per-capability toggle.
 */
export const RaSessionReviewPage = () => {
  const intl = useIntl();

  return (
    <Box p={4}>
      <Typography variant="h4" gutterBottom>
        {intl.formatMessage({ id: 'raSessionReview.page.title' })}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        {intl.formatMessage({ id: 'raSessionReview.page.comingSoon' })}
      </Typography>
    </Box>
  );
};

export default RaSessionReviewPage;
